// import React, { useState } from 'react';
// import { 
//   Shield, Cloud, BarChart3, Users, Headphones, ChevronDown, 
//   ArrowRight, Menu, X, CheckCircle, TrendingUp, MessageSquare, 
//   FileText, DollarSign, CloudOff, Zap, Clock, Target, HeartHandshake,
//   Calendar, UserPlus, Handshake, Phone
// } from 'lucide-react';

// // --- Components ---

// const Navbar = () => {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   return (
//     <nav className="bg-white border-b border-gray-100 sticky top-0 z-50">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex justify-between items-center h-16">
//           <div className="flex items-center gap-2">
//             <div className="w-8 h-8 bg-emerald-600 rounded-lg flex items-center justify-center">
//               <svg viewBox="0 0 24 24" className="w-5 h-5 text-white" fill="currentColor">
//                 <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
//               </svg>
//             </div>
//             <span className="text-xl font-bold text-gray-900">TerraWeb</span>
//           </div>

//           <div className="hidden md:flex items-center gap-8">
//             <a href="#" className="text-gray-600 hover:text-gray-900 text-sm font-medium">Home</a>
//             <a href="#" className="text-emerald-600 text-sm font-medium border-b-2 border-emerald-600 pb-5 pt-5">About Us</a>
//             <a href="#" className="text-gray-600 hover:text-gray-900 text-sm font-medium flex items-center gap-1">Solutions <ChevronDown className="w-4 h-4"/></a>
//             <a href="#" className="text-gray-600 hover:text-gray-900 text-sm font-medium">Platform</a>
//             <a href="#" className="text-gray-600 hover:text-gray-900 text-sm font-medium flex items-center gap-1">Resources <ChevronDown className="w-4 h-4"/></a>
//             <a href="#" className="text-gray-600 hover:text-gray-900 text-sm font-medium">Contact</a>
//           </div>

//           <div className="hidden md:block">
//             <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-2 rounded-lg text-sm font-medium transition-colors">
//               Request Demo
//             </button>
//           </div>

//           <button className="md:hidden" onClick={() => setMobileOpen(!mobileOpen)}>
//             {mobileOpen ? <X className="w-6 h-6"/> : <Menu className="w-6 h-6"/>}
//           </button>
//         </div>
//       </div>

//       {mobileOpen && (
//         <div className="md:hidden bg-white border-t px-4 py-4 space-y-3">
//           <a href="#" className="block text-gray-600 py-2">Home</a>
//           <a href="#" className="block text-emerald-600 py-2 font-medium">About Us</a>
//           <a href="#" className="block text-gray-600 py-2">Solutions</a>
//           <a href="#" className="block text-gray-600 py-2">Platform</a>
//           <a href="#" className="block text-gray-600 py-2">Resources</a>
//           <a href="#" className="block text-gray-600 py-2">Contact</a>
//           <button className="w-full bg-emerald-600 text-white px-5 py-2 rounded-lg text-sm font-medium mt-2">
//             Request Demo
//           </button>
//         </div>
//       )}
//     </nav>
//   );
// };

// const HeroSection = () => {
//   return (
//     <section className="bg-[#0f172a] text-white relative overflow-hidden">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
//         <div className="grid lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <p className="text-emerald-400 text-sm font-semibold tracking-wider uppercase mb-4">About TerraWeb</p>
//             <h1 className="text-4xl lg:text-5xl font-bold leading-tight mb-6">
//               Building Digital Infrastructure<br/>for Stronger Cooperatives
//             </h1>
//             <p className="text-gray-300 text-lg mb-8 max-w-lg">
//               TerraWeb empowers agricultural societies, cooperatives, and organizations with connected tools to manage operations, engage members, and make data-driven decisions.
//             </p>
//             <div className="flex flex-wrap gap-4 mb-10">
//               <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-lg font-medium flex items-center gap-2 transition-colors">
//                 Request Demo <ArrowRight className="w-4 h-4"/>
//               </button>
//               <button className="border border-gray-500 hover:border-gray-300 text-white px-6 py-3 rounded-lg font-medium transition-colors">
//                 Explore Platform
//               </button>
//             </div>
//             <div className="flex items-center gap-4">
//               <div className="flex -space-x-3">
//                 {[1,2,3,4,5].map(i => (
//                   <div key={i} className="w-10 h-10 rounded-full bg-gray-600 border-2 border-[#0f172a] flex items-center justify-center text-xs font-medium">
//                     {String.fromCharCode(64 + i)}
//                   </div>
//                 ))}
//               </div>
//               <p className="text-gray-400 text-sm">Trusted by forward-thinking organizations</p>
//             </div>
//           </div>

//           <div className="relative">
//             <div className="bg-white rounded-xl shadow-2xl overflow-hidden">
//               <div className="flex">
//                 {/* Sidebar */}
//                 <div className="w-48 bg-gray-50 border-r p-4 hidden sm:block">
//                   <div className="flex items-center gap-2 mb-6">
//                     <div className="w-6 h-6 bg-emerald-600 rounded flex items-center justify-center">
//                       <svg viewBox="0 0 24 24" className="w-4 h-4 text-white" fill="currentColor"><path d="M12 2L2 7l10 5 10-5-10-5z"/></svg>
//                     </div>
//                     <span className="font-semibold text-gray-800 text-sm">TerraWeb</span>
//                   </div>
//                   <div className="space-y-1">
//                     {['Dashboard','Collections','Members','Finance','Messaging','Reports','Settings'].map((item, idx) => (
//                       <div key={item} className={`flex items-center gap-3 px-3 py-2 rounded-lg text-sm ${idx === 0 ? 'bg-emerald-600 text-white' : 'text-gray-600 hover:bg-gray-100'}`}>
//                         <div className={`w-4 h-4 rounded ${idx === 0 ? 'bg-white/20' : 'bg-gray-200'}`}/>
//                         {item}
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 {/* Dashboard Content */}
//                 <div className="flex-1 p-4 sm:p-6">
//                   <div className="flex justify-between items-center mb-6">
//                     <h3 className="font-semibold text-gray-800">Dashboard</h3>
//                     <div className="flex items-center gap-2">
//                       <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 text-xs font-bold">JW</div>
//                       <div className="hidden sm:block">
//                         <p className="text-xs font-medium text-gray-800">Jane Wanjiku</p>
//                         <p className="text-xs text-gray-500">Admin</p>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
//                     {[
//                       {label:'Total Farmers', val:'2,450'},
//                       {label:'Collections (Today)', val:'8,750 L'},
//                       {label:'Total Payouts', val:'KES 1.2M'},
//                       {label:'Active Cooperatives', val:'32'}
//                     ].map(stat => (
//                       <div key={stat.label} className="bg-gray-50 rounded-lg p-3">
//                         <p className="text-xs text-gray-500 mb-1">{stat.label}</p>
//                         <p className="text-lg font-bold text-gray-800">{stat.val}</p>
//                       </div>
//                     ))}
//                   </div>

//                   <div className="grid lg:grid-cols-3 gap-4">
//                     <div className="lg:col-span-2 bg-gray-50 rounded-lg p-4">
//                       <div className="flex justify-between items-center mb-3">
//                         <p className="text-sm font-medium text-gray-700">Collection Overview</p>
//                         <div className="flex gap-3 text-xs">
//                           <span className="flex items-center gap-1"><div className="w-2 h-2 bg-emerald-500 rounded-full"/> Milk</span>
//                           <span className="flex items-center gap-1"><div className="w-2 h-2 bg-blue-400 rounded-full"/> Coffee</span>
//                         </div>
//                       </div>
//                       <div className="h-24 flex items-end gap-2">
//                         {[40,65,45,80,55,70,85].map((h,i) => (
//                           <div key={i} className="flex-1 flex flex-col gap-1">
//                             <div className="bg-emerald-500 rounded-t" style={{height: `${h}%`}}/>
//                             <div className="bg-blue-400 rounded-t" style={{height: `${h*0.6}%`}}/>
//                           </div>
//                         ))}
//                       </div>
//                       <div className="flex justify-between mt-2 text-xs text-gray-400">
//                         {['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].map(d => <span key={d}>{d}</span>)}
//                       </div>
//                     </div>

//                     <div className="bg-gray-50 rounded-lg p-4">
//                       <p className="text-sm font-medium text-gray-700 mb-3">Recent Activity</p>
//                       <div className="space-y-3">
//                         {[
//                           {icon:'🟢', text:'New collection recorded', sub:'Kagumo Dairy Cooperative', time:'2 min ago'},
//                           {icon:'💰', text:'Payment processed', sub:'Mutha Farmers Society', time:'15 min ago'},
//                           {icon:'👤', text:'New member added', sub:'The Future Cooperative', time:'1 hour ago'},
//                           {icon:'📄', text:'Report generated', sub:'Kagumo Dairy Cooperative', time:'2 hours ago'},
//                         ].map((act, i) => (
//                           <div key={i} className="flex gap-2">
//                             <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center text-xs shadow-sm">{act.icon}</div>
//                             <div className="flex-1 min-w-0">
//                               <p className="text-xs font-medium text-gray-800 truncate">{act.text}</p>
//                               <p className="text-xs text-gray-500 truncate">{act.sub}</p>
//                             </div>
//                             <span className="text-xs text-gray-400 whitespace-nowrap">{act.time}</span>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>

//                   <div className="grid grid-cols-2 gap-4 mt-4">
//                     <div className="bg-gray-50 rounded-lg p-4">
//                       <p className="text-sm font-medium text-gray-700 mb-2">Payout Summary</p>
//                       <div className="flex items-center gap-3">
//                         <div className="w-12 h-12 rounded-full border-4 border-emerald-500 border-t-gray-200"/>
//                         <div>
//                           <p className="text-xs text-gray-500">KES 1,200,000</p>
//                           <p className="text-xs text-gray-400">Total Payouts</p>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="bg-gray-50 rounded-lg p-4">
//                       <p className="text-sm font-medium text-gray-700 mb-2">Top Cooperatives</p>
//                       <div className="space-y-2">
//                         {['Kagumo Dairy Cooperative','Mutha Farmers Society','The Future Cooperative'].map((c,i) => (
//                           <div key={c} className="flex items-center gap-2">
//                             <div className="w-2 h-2 rounded-full bg-emerald-500"/>
//                             <p className="text-xs text-gray-600 truncate">{c}</p>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// const TrustBadges = () => {
//   const badges = [
//     {icon: Shield, title: 'Secure & Reliable', desc: 'Enterprise-grade security to protect your data'},
//     {icon: Cloud, title: 'Accessible Anywhere', desc: 'Works on mobile and web, online or offline'},
//     {icon: BarChart3, title: 'Real-time Insights', desc: 'Up-to-date data for better decisions'},
//     {icon: Users, title: 'Built for Cooperatives', desc: 'Designed around real cooperative workflows'},
//     {icon: Headphones, title: 'Dedicated Support', desc: "We're with you every step of the way"},
//   ];

//   return (
//     <section className="bg-white py-8 border-b">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
//           {badges.map(badge => (
//             <div key={badge.title} className="flex items-start gap-3">
//               <badge.icon className="w-6 h-6 text-emerald-600 flex-shrink-0 mt-0.5"/>
//               <div>
//                 <p className="text-sm font-semibold text-gray-800">{badge.title}</p>
//                 <p className="text-xs text-gray-500 mt-0.5">{badge.desc}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// const StorySection = () => {
//   return (
//     <section className="bg-white py-16 lg:py-24">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="grid lg:grid-cols-2 gap-12 items-center">
//           <div className="grid grid-cols-2 gap-4">
//             <div className="space-y-4">
//               <div className="bg-emerald-50 rounded-2xl overflow-hidden aspect-[4/3]">
//                 <img src="https://images.unsplash.com/photo-1593113598332-cd288d649433?w=400&h=300&fit=crop" alt="Farmer with tablet" className="w-full h-full object-cover"/>
//               </div>
//               <div className="bg-emerald-100 rounded-xl p-4">
//                 <div className="flex items-center gap-2 mb-2">
//                   <div className="w-8 h-8 bg-emerald-600 rounded-full flex items-center justify-center text-white text-xs">$$</div>
//                   <p className="text-sm font-medium text-gray-800">We exist to simplify operations so cooperatives can thrive.</p>
//                 </div>
//               </div>
//             </div>
//             <div className="space-y-4 pt-8">
//               <div className="bg-orange-50 rounded-2xl overflow-hidden aspect-[4/3]">
//                 <img src="https://images.unsplash.com/photo-1523741543316-beb7fc7023d8?w=400&h=300&fit=crop" alt="Coffee cherries" className="w-full h-full object-cover"/>
//               </div>
//               <div className="bg-gray-100 rounded-2xl overflow-hidden aspect-[4/3]">
//                 <img src="https://images.unsplash.com/photo-1560493676-04071c5f467b?w=400&h=300&fit=crop" alt="Milk cans" className="w-full h-full object-cover"/>
//               </div>
//             </div>
//           </div>

//           <div>
//             <p className="text-emerald-600 text-sm font-semibold tracking-wider uppercase mb-4">Our Story</p>
//             <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
//               Born from real challenges.<br/>Built for real impact.
//             </h2>
//             <p className="text-gray-600 mb-4">
//               We saw hardworking farmers and cooperative leaders struggle with manual records, delayed payments, poor communication, and fragmented data. These challenges slow growth and weaken trust.
//             </p>
//             <p className="text-gray-600 mb-4">
//               TerraWeb was created to change that.
//             </p>
//             <p className="text-gray-600 mb-8">
//               We are building the digital foundation that helps cooperatives operate smarter, transparently, and sustainably.
//             </p>
//             <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-lg font-medium flex items-center gap-2 transition-colors">
//               Our Mission <ArrowRight className="w-4 h-4"/>
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// const FeaturesSection = () => {
//   const features = [
//     {icon: CloudOff, title: 'Collection Management', desc: 'Digitize collection processes for milk, coffee, and more.'},
//     {icon: Users, title: 'Member Management', desc: 'Maintain accurate member records and engagement.'},
//     {icon: DollarSign, title: 'Finance & Payouts', desc: 'Automate calculations and payouts with transparency.'},
//     {icon: MessageSquare, title: 'Communication', desc: 'Connect members and leaders instantly and effectively.'},
//     {icon: TrendingUp, title: 'Reports & Analytics', desc: 'Get insights that drive smarter decisions.'},
//   ];

//   return (
//     <section className="bg-gray-50 py-16 lg:py-24">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-12">
//           <p className="text-emerald-600 text-sm font-semibold tracking-wider uppercase mb-3">What We Do</p>
//           <h2 className="text-3xl font-bold text-gray-900">All-in-one platform for cooperative success</h2>
//         </div>

//         <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
//           {features.map(f => (
//             <div key={f.title} className="bg-white rounded-xl p-6 border border-gray-100 hover:shadow-lg transition-shadow">
//               <div className="w-12 h-12 bg-emerald-50 rounded-xl flex items-center justify-center mb-4">
//                 <f.icon className="w-6 h-6 text-emerald-600"/>
//               </div>
//               <h3 className="font-semibold text-gray-900 mb-2">{f.title}</h3>
//               <p className="text-sm text-gray-500">{f.desc}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// const ValuesSection = () => {
//   const values = [
//     {icon: CheckCircle, title: 'Integrity', desc: 'We operate with honesty and transparency.'},
//     {icon: Zap, title: 'Innovation', desc: 'We build simple, smart solutions that scale.'},
//     {icon: Clock, title: 'Reliability', desc: 'We deliver systems you can count on every day.'},
//     {icon: Target, title: 'Simplicity', desc: 'We make technology easy and accessible.'},
//     {icon: HeartHandshake, title: 'Impact', desc: 'We are committed to empowering communities.'},
//   ];

//   return (
//     <section className="bg-white py-16">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <p className="text-emerald-600 text-sm font-semibold tracking-wider uppercase mb-8 text-center">Our Values</p>
//         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
//           {values.map(v => (
//             <div key={v.title} className="text-center">
//               <div className="w-10 h-10 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-3">
//                 <v.icon className="w-5 h-5 text-emerald-600"/>
//               </div>
//               <h3 className="font-semibold text-gray-900 mb-1">{v.title}</h3>
//               <p className="text-xs text-gray-500">{v.desc}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// const CTABanner = () => {
//   return (
//     <section className="py-8">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="bg-[#0f172a] rounded-2xl p-8 lg:p-12 flex flex-col lg:flex-row items-center justify-between gap-6">
//           <div className="flex items-center gap-6">
//             <div className="w-16 h-16 bg-emerald-600/20 rounded-full flex items-center justify-center flex-shrink-0">
//               <Handshake className="w-8 h-8 text-emerald-400"/>
//             </div>
//             <div>
//               <h3 className="text-xl lg:text-2xl font-bold text-white mb-1">Let's build stronger cooperatives together</h3>
//               <p className="text-gray-400">Join organizations already transforming operations with TerraWeb.</p>
//             </div>
//           </div>
//           <div className="flex gap-3 flex-shrink-0">
//             <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-lg font-medium flex items-center gap-2 transition-colors">
//               Partner With Us <ArrowRight className="w-4 h-4"/>
//             </button>
//             <button className="border border-gray-600 hover:border-gray-400 text-white px-6 py-3 rounded-lg font-medium transition-colors">
//               Contact Sales
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// const WorkTogetherSection = () => {
//   const options = [
//     {icon: Calendar, color: 'bg-emerald-100 text-emerald-600', title: 'Request a Demo', desc: 'See how TerraWeb can transform your operations.', cta: 'Book a Demo', ctaColor: 'text-emerald-600'},
//     {icon: UserPlus, color: 'bg-blue-100 text-blue-600', title: 'Become a Pilot Partner', desc: 'Be among our early partners and shape the future together.', cta: 'Join Pilot Program', ctaColor: 'text-blue-600'},
//     {icon: Handshake, color: 'bg-purple-100 text-purple-600', title: 'Partnerships', desc: 'Explore collaboration opportunities with us.', cta: 'Explore Partnerships', ctaColor: 'text-purple-600'},
//     {icon: Phone, color: 'bg-orange-100 text-orange-600', title: 'Talk to Sales', desc: 'Speak with our team about your specific needs.', cta: 'Contact Sales', ctaColor: 'text-orange-600'},
//   ];

//   return (
//     <section className="bg-white py-16 lg:py-24">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-12">
//           <h2 className="text-3xl font-bold text-gray-900 mb-2">How we can work together</h2>
//           <p className="text-gray-500">Choose the path that fits your organization.</p>
//         </div>

//         <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
//           {options.map(opt => (
//             <div key={opt.title} className="border border-gray-100 rounded-xl p-6 hover:shadow-lg transition-shadow">
//               <div className={`w-12 h-12 ${opt.color} rounded-xl flex items-center justify-center mb-4`}>
//                 <opt.icon className="w-6 h-6"/>
//               </div>
//               <h3 className="font-semibold text-gray-900 mb-2">{opt.title}</h3>
//               <p className="text-sm text-gray-500 mb-4">{opt.desc}</p>
//               <a href="#" className={`text-sm font-medium ${opt.ctaColor} flex items-center gap-1 hover:gap-2 transition-all`}>
//                 {opt.cta} <ArrowRight className="w-4 h-4"/>
//               </a>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// const Footer = () => {
//   return (
//     <footer className="bg-gray-50 border-t py-12">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex flex-col md:flex-row justify-between items-center gap-4">
//           <div className="flex items-center gap-2">
//             <div className="w-8 h-8 bg-emerald-600 rounded-lg flex items-center justify-center">
//               <svg viewBox="0 0 24 24" className="w-5 h-5 text-white" fill="currentColor">
//                 <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
//               </svg>
//             </div>
//             <span className="text-lg font-bold text-gray-900">TerraWeb</span>
//           </div>
//           <p className="text-sm text-gray-500">© 2026 TerraWeb. All rights reserved.</p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// // --- Main App with Preview Toggle ---

// export default function Services() {
//   const [showPreview, setShowPreview] = useState(true);

//   return (
//     <div className="min-h-screen bg-gray-100">
//       {/* Preview Toggle Bar */}
//       <div className="bg-gray-900 text-white px-4 py-3 flex items-center justify-between sticky top-0 z-[60]">
//         <div className="flex items-center gap-3">
//           <div className="w-3 h-3 rounded-full bg-red-500"/>
//           <div className="w-3 h-3 rounded-full bg-yellow-500"/>
//           <div className="w-3 h-3 rounded-full bg-green-500"/>
//           <span className="text-sm font-medium ml-2">TerraWeb Landing Page — Preview Mode</span>
//         </div>
//         <div className="flex items-center gap-3">
//           <button 
//             onClick={() => setShowPreview(!showPreview)}
//             className="text-xs bg-gray-700 hover:bg-gray-600 px-3 py-1.5 rounded transition-colors"
//           >
//             {showPreview ? 'Show Code' : 'Show Preview'}
//           </button>
//         </div>
//       </div>

//       {showPreview ? (
//         <div className="bg-white">
//           <Navbar/>
//           <HeroSection/>
//           <TrustBadges/>
//           <StorySection/>
//           <FeaturesSection/>
//           <ValuesSection/>
//           <CTABanner/>
//           <WorkTogetherSection/>
//           <Footer/>
//         </div>
//       ) : (
//         <div className="max-w-5xl mx-auto p-6">
//           <div className="bg-gray-900 rounded-xl overflow-hidden">
//             <div className="flex items-center justify-between px-4 py-3 bg-gray-800 border-b border-gray-700">
//               <span className="text-sm text-gray-400">TerraWebPage.jsx</span>
//               <button 
//                 onClick={() => {
//                   const code = document.getElementById('code-block').innerText;
//                   navigator.clipboard.writeText(code);
//                   alert('Code copied to clipboard!');
//                 }}
//                 className="text-xs bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-1.5 rounded transition-colors"
//               >
//                 Copy All Code
//               </button>
//             </div>
//             <pre id="code-block" className="p-6 overflow-auto max-h-[80vh] text-sm text-gray-300 font-mono leading-relaxed">
// {`import React, { useState } from 'react';
// import { 
//   Shield, Cloud, BarChart3, Users, Headphones, ChevronDown, 
//   ArrowRight, Menu, X, CheckCircle, TrendingUp, MessageSquare, 
//   FileText, DollarSign, CloudOff, Zap, Clock, Target, HeartHandshake,
//   Calendar, UserPlus, Handshake, Phone
// } from 'lucide-react';

// // --- Components ---

// const Navbar = () => {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   return (
//     <nav className="bg-white border-b border-gray-100 sticky top-0 z-50">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex justify-between items-center h-16">
//           <div className="flex items-center gap-2">
//             <div className="w-8 h-8 bg-emerald-600 rounded-lg flex items-center justify-center">
//               <svg viewBox="0 0 24 24" className="w-5 h-5 text-white" fill="currentColor">
//                 <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
//               </svg>
//             </div>
//             <span className="text-xl font-bold text-gray-900">TerraWeb</span>
//           </div>

//           <div className="hidden md:flex items-center gap-8">
//             <a href="#" className="text-gray-600 hover:text-gray-900 text-sm font-medium">Home</a>
//             <a href="#" className="text-emerald-600 text-sm font-medium border-b-2 border-emerald-600 pb-5 pt-5">About Us</a>
//             <a href="#" className="text-gray-600 hover:text-gray-900 text-sm font-medium flex items-center gap-1">Solutions <ChevronDown className="w-4 h-4"/></a>
//             <a href="#" className="text-gray-600 hover:text-gray-900 text-sm font-medium">Platform</a>
//             <a href="#" className="text-gray-600 hover:text-gray-900 text-sm font-medium flex items-center gap-1">Resources <ChevronDown className="w-4 h-4"/></a>
//             <a href="#" className="text-gray-600 hover:text-gray-900 text-sm font-medium">Contact</a>
//           </div>

//           <div className="hidden md:block">
//             <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-2 rounded-lg text-sm font-medium transition-colors">
//               Request Demo
//             </button>
//           </div>

//           <button className="md:hidden" onClick={() => setMobileOpen(!mobileOpen)}>
//             {mobileOpen ? <X className="w-6 h-6"/> : <Menu className="w-6 h-6"/>}
//           </button>
//         </div>
//       </div>

//       {mobileOpen && (
//         <div className="md:hidden bg-white border-t px-4 py-4 space-y-3">
//           <a href="#" className="block text-gray-600 py-2">Home</a>
//           <a href="#" className="block text-emerald-600 py-2 font-medium">About Us</a>
//           <a href="#" className="block text-gray-600 py-2">Solutions</a>
//           <a href="#" className="block text-gray-600 py-2">Platform</a>
//           <a href="#" className="block text-gray-600 py-2">Resources</a>
//           <a href="#" className="block text-gray-600 py-2">Contact</a>
//           <button className="w-full bg-emerald-600 text-white px-5 py-2 rounded-lg text-sm font-medium mt-2">
//             Request Demo
//           </button>
//         </div>
//       )}
//     </nav>
//   );
// };

// const HeroSection = () => {
//   return (
//     <section className="bg-[#0f172a] text-white relative overflow-hidden">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
//         <div className="grid lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <p className="text-emerald-400 text-sm font-semibold tracking-wider uppercase mb-4">About TerraWeb</p>
//             <h1 className="text-4xl lg:text-5xl font-bold leading-tight mb-6">
//               Building Digital Infrastructure<br/>for Stronger Cooperatives
//             </h1>
//             <p className="text-gray-300 text-lg mb-8 max-w-lg">
//               TerraWeb empowers agricultural societies, cooperatives, and organizations with connected tools to manage operations, engage members, and make data-driven decisions.
//             </p>
//             <div className="flex flex-wrap gap-4 mb-10">
//               <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-lg font-medium flex items-center gap-2 transition-colors">
//                 Request Demo <ArrowRight className="w-4 h-4"/>
//               </button>
//               <button className="border border-gray-500 hover:border-gray-300 text-white px-6 py-3 rounded-lg font-medium transition-colors">
//                 Explore Platform
//               </button>
//             </div>
//             <div className="flex items-center gap-4">
//               <div className="flex -space-x-3">
//                 {[1,2,3,4,5].map(i => (
//                   <div key={i} className="w-10 h-10 rounded-full bg-gray-600 border-2 border-[#0f172a] flex items-center justify-center text-xs font-medium">
//                     {String.fromCharCode(64 + i)}
//                   </div>
//                 ))}
//               </div>
//               <p className="text-gray-400 text-sm">Trusted by forward-thinking organizations</p>
//             </div>
//           </div>

//           <div className="relative">
//             <div className="bg-white rounded-xl shadow-2xl overflow-hidden">
//               <div className="flex">
//                 {/* Sidebar */}
//                 <div className="w-48 bg-gray-50 border-r p-4 hidden sm:block">
//                   <div className="flex items-center gap-2 mb-6">
//                     <div className="w-6 h-6 bg-emerald-600 rounded flex items-center justify-center">
//                       <svg viewBox="0 0 24 24" className="w-4 h-4 text-white" fill="currentColor"><path d="M12 2L2 7l10 5 10-5-10-5z"/></svg>
//                     </div>
//                     <span className="font-semibold text-gray-800 text-sm">TerraWeb</span>
//                   </div>
//                   <div className="space-y-1">
//                     {['Dashboard','Collections','Members','Finance','Messaging','Reports','Settings'].map((item, idx) => (
//                       <div key={item} className={\`flex items-center gap-3 px-3 py-2 rounded-lg text-sm \${idx === 0 ? 'bg-emerald-600 text-white' : 'text-gray-600 hover:bg-gray-100'}\`}>
//                         <div className={\`w-4 h-4 rounded \${idx === 0 ? 'bg-white/20' : 'bg-gray-200'}\`}/>
//                         {item}
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 {/* Dashboard Content */}
//                 <div className="flex-1 p-4 sm:p-6">
//                   <div className="flex justify-between items-center mb-6">
//                     <h3 className="font-semibold text-gray-800">Dashboard</h3>
//                     <div className="flex items-center gap-2">
//                       <div className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 text-xs font-bold">JW</div>
//                       <div className="hidden sm:block">
//                         <p className="text-xs font-medium text-gray-800">Jane Wanjiku</p>
//                         <p className="text-xs text-gray-500">Admin</p>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
//                     {[
//                       {label:'Total Farmers', val:'2,450'},
//                       {label:'Collections (Today)', val:'8,750 L'},
//                       {label:'Total Payouts', val:'KES 1.2M'},
//                       {label:'Active Cooperatives', val:'32'}
//                     ].map(stat => (
//                       <div key={stat.label} className="bg-gray-50 rounded-lg p-3">
//                         <p className="text-xs text-gray-500 mb-1">{stat.label}</p>
//                         <p className="text-lg font-bold text-gray-800">{stat.val}</p>
//                       </div>
//                     ))}
//                   </div>

//                   <div className="grid lg:grid-cols-3 gap-4">
//                     <div className="lg:col-span-2 bg-gray-50 rounded-lg p-4">
//                       <div className="flex justify-between items-center mb-3">
//                         <p className="text-sm font-medium text-gray-700">Collection Overview</p>
//                         <div className="flex gap-3 text-xs">
//                           <span className="flex items-center gap-1"><div className="w-2 h-2 bg-emerald-500 rounded-full"/> Milk</span>
//                           <span className="flex items-center gap-1"><div className="w-2 h-2 bg-blue-400 rounded-full"/> Coffee</span>
//                         </div>
//                       </div>
//                       <div className="h-24 flex items-end gap-2">
//                         {[40,65,45,80,55,70,85].map((h,i) => (
//                           <div key={i} className="flex-1 flex flex-col gap-1">
//                             <div className="bg-emerald-500 rounded-t" style={{height: \`\${h}%\`}}/>
//                             <div className="bg-blue-400 rounded-t" style={{height: \`\${h*0.6}%\`}}/>
//                           </div>
//                         ))}
//                       </div>
//                       <div className="flex justify-between mt-2 text-xs text-gray-400">
//                         {['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].map(d => <span key={d}>{d}</span>)}
//                       </div>
//                     </div>

//                     <div className="bg-gray-50 rounded-lg p-4">
//                       <p className="text-sm font-medium text-gray-700 mb-3">Recent Activity</p>
//                       <div className="space-y-3">
//                         {[
//                           {icon:'🟢', text:'New collection recorded', sub:'Kagumo Dairy Cooperative', time:'2 min ago'},
//                           {icon:'💰', text:'Payment processed', sub:'Mutha Farmers Society', time:'15 min ago'},
//                           {icon:'👤', text:'New member added', sub:'The Future Cooperative', time:'1 hour ago'},
//                           {icon:'📄', text:'Report generated', sub:'Kagumo Dairy Cooperative', time:'2 hours ago'},
//                         ].map((act, i) => (
//                           <div key={i} className="flex gap-2">
//                             <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center text-xs shadow-sm">{act.icon}</div>
//                             <div className="flex-1 min-w-0">
//                               <p className="text-xs font-medium text-gray-800 truncate">{act.text}</p>
//                               <p className="text-xs text-gray-500 truncate">{act.sub}</p>
//                             </div>
//                             <span className="text-xs text-gray-400 whitespace-nowrap">{act.time}</span>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>

//                   <div className="grid grid-cols-2 gap-4 mt-4">
//                     <div className="bg-gray-50 rounded-lg p-4">
//                       <p className="text-sm font-medium text-gray-700 mb-2">Payout Summary</p>
//                       <div className="flex items-center gap-3">
//                         <div className="w-12 h-12 rounded-full border-4 border-emerald-500 border-t-gray-200"/>
//                         <div>
//                           <p className="text-xs text-gray-500">KES 1,200,000</p>
//                           <p className="text-xs text-gray-400">Total Payouts</p>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="bg-gray-50 rounded-lg p-4">
//                       <p className="text-sm font-medium text-gray-700 mb-2">Top Cooperatives</p>
//                       <div className="space-y-2">
//                         {['Kagumo Dairy Cooperative','Mutha Farmers Society','The Future Cooperative'].map((c,i) => (
//                           <div key={c} className="flex items-center gap-2">
//                             <div className="w-2 h-2 rounded-full bg-emerald-500"/>
//                             <p className="text-xs text-gray-600 truncate">{c}</p>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// const TrustBadges = () => {
//   const badges = [
//     {icon: Shield, title: 'Secure & Reliable', desc: 'Enterprise-grade security to protect your data'},
//     {icon: Cloud, title: 'Accessible Anywhere', desc: 'Works on mobile and web, online or offline'},
//     {icon: BarChart3, title: 'Real-time Insights', desc: 'Up-to-date data for better decisions'},
//     {icon: Users, title: 'Built for Cooperatives', desc: 'Designed around real cooperative workflows'},
//     {icon: Headphones, title: 'Dedicated Support', desc: "We're with you every step of the way"},
//   ];

//   return (
//     <section className="bg-white py-8 border-b">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
//           {badges.map(badge => (
//             <div key={badge.title} className="flex items-start gap-3">
//               <badge.icon className="w-6 h-6 text-emerald-600 flex-shrink-0 mt-0.5"/>
//               <div>
//                 <p className="text-sm font-semibold text-gray-800">{badge.title}</p>
//                 <p className="text-xs text-gray-500 mt-0.5">{badge.desc}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// const StorySection = () => {
//   return (
//     <section className="bg-white py-16 lg:py-24">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="grid lg:grid-cols-2 gap-12 items-center">
//           <div className="grid grid-cols-2 gap-4">
//             <div className="space-y-4">
//               <div className="bg-emerald-50 rounded-2xl overflow-hidden aspect-[4/3]">
//                 <img src="https://images.unsplash.com/photo-1593113598332-cd288d649433?w=400&h=300&fit=crop" alt="Farmer with tablet" className="w-full h-full object-cover"/>
//               </div>
//               <div className="bg-emerald-100 rounded-xl p-4">
//                 <div className="flex items-center gap-2 mb-2">
//                   <div className="w-8 h-8 bg-emerald-600 rounded-full flex items-center justify-center text-white text-xs">$$</div>
//                   <p className="text-sm font-medium text-gray-800">We exist to simplify operations so cooperatives can thrive.</p>
//                 </div>
//               </div>
//             </div>
//             <div className="space-y-4 pt-8">
//               <div className="bg-orange-50 rounded-2xl overflow-hidden aspect-[4/3]">
//                 <img src="https://images.unsplash.com/photo-1523741543316-beb7fc7023d8?w=400&h=300&fit=crop" alt="Coffee cherries" className="w-full h-full object-cover"/>
//               </div>
//               <div className="bg-gray-100 rounded-2xl overflow-hidden aspect-[4/3]">
//                 <img src="https://images.unsplash.com/photo-1560493676-04071c5f467b?w=400&h=300&fit=crop" alt="Milk cans" className="w-full h-full object-cover"/>
//               </div>
//             </div>
//           </div>

//           <div>
//             <p className="text-emerald-600 text-sm font-semibold tracking-wider uppercase mb-4">Our Story</p>
//             <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
//               Born from real challenges.<br/>Built for real impact.
//             </h2>
//             <p className="text-gray-600 mb-4">
//               We saw hardworking farmers and cooperative leaders struggle with manual records, delayed payments, poor communication, and fragmented data. These challenges slow growth and weaken trust.
//             </p>
//             <p className="text-gray-600 mb-4">
//               TerraWeb was created to change that.
//             </p>
//             <p className="text-gray-600 mb-8">
//               We are building the digital foundation that helps cooperatives operate smarter, transparently, and sustainably.
//             </p>
//             <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-lg font-medium flex items-center gap-2 transition-colors">
//               Our Mission <ArrowRight className="w-4 h-4"/>
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// const FeaturesSection = () => {
//   const features = [
//     {icon: CloudOff, title: 'Collection Management', desc: 'Digitize collection processes for milk, coffee, and more.'},
//     {icon: Users, title: 'Member Management', desc: 'Maintain accurate member records and engagement.'},
//     {icon: DollarSign, title: 'Finance & Payouts', desc: 'Automate calculations and payouts with transparency.'},
//     {icon: MessageSquare, title: 'Communication', desc: 'Connect members and leaders instantly and effectively.'},
//     {icon: TrendingUp, title: 'Reports & Analytics', desc: 'Get insights that drive smarter decisions.'},
//   ];

//   return (
//     <section className="bg-gray-50 py-16 lg:py-24">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-12">
//           <p className="text-emerald-600 text-sm font-semibold tracking-wider uppercase mb-3">What We Do</p>
//           <h2 className="text-3xl font-bold text-gray-900">All-in-one platform for cooperative success</h2>
//         </div>

//         <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
//           {features.map(f => (
//             <div key={f.title} className="bg-white rounded-xl p-6 border border-gray-100 hover:shadow-lg transition-shadow">
//               <div className="w-12 h-12 bg-emerald-50 rounded-xl flex items-center justify-center mb-4">
//                 <f.icon className="w-6 h-6 text-emerald-600"/>
//               </div>
//               <h3 className="font-semibold text-gray-900 mb-2">{f.title}</h3>
//               <p className="text-sm text-gray-500">{f.desc}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// const ValuesSection = () => {
//   const values = [
//     {icon: CheckCircle, title: 'Integrity', desc: 'We operate with honesty and transparency.'},
//     {icon: Zap, title: 'Innovation', desc: 'We build simple, smart solutions that scale.'},
//     {icon: Clock, title: 'Reliability', desc: 'We deliver systems you can count on every day.'},
//     {icon: Target, title: 'Simplicity', desc: 'We make technology easy and accessible.'},
//     {icon: HeartHandshake, title: 'Impact', desc: 'We are committed to empowering communities.'},
//   ];

//   return (
//     <section className="bg-white py-16">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <p className="text-emerald-600 text-sm font-semibold tracking-wider uppercase mb-8 text-center">Our Values</p>
//         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
//           {values.map(v => (
//             <div key={v.title} className="text-center">
//               <div className="w-10 h-10 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-3">
//                 <v.icon className="w-5 h-5 text-emerald-600"/>
//               </div>
//               <h3 className="font-semibold text-gray-900 mb-1">{v.title}</h3>
//               <p className="text-xs text-gray-500">{v.desc}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// const CTABanner = () => {
//   return (
//     <section className="py-8">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="bg-[#0f172a] rounded-2xl p-8 lg:p-12 flex flex-col lg:flex-row items-center justify-between gap-6">
//           <div className="flex items-center gap-6">
//             <div className="w-16 h-16 bg-emerald-600/20 rounded-full flex items-center justify-center flex-shrink-0">
//               <Handshake className="w-8 h-8 text-emerald-400"/>
//             </div>
//             <div>
//               <h3 className="text-xl lg:text-2xl font-bold text-white mb-1">Let's build stronger cooperatives together</h3>
//               <p className="text-gray-400">Join organizations already transforming operations with TerraWeb.</p>
//             </div>
//           </div>
//           <div className="flex gap-3 flex-shrink-0">
//             <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-lg font-medium flex items-center gap-2 transition-colors">
//               Partner With Us <ArrowRight className="w-4 h-4"/>
//             </button>
//             <button className="border border-gray-600 hover:border-gray-400 text-white px-6 py-3 rounded-lg font-medium transition-colors">
//               Contact Sales
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// const WorkTogetherSection = () => {
//   const options = [
//     {icon: Calendar, color: 'bg-emerald-100 text-emerald-600', title: 'Request a Demo', desc: 'See how TerraWeb can transform your operations.', cta: 'Book a Demo', ctaColor: 'text-emerald-600'},
//     {icon: UserPlus, color: 'bg-blue-100 text-blue-600', title: 'Become a Pilot Partner', desc: 'Be among our early partners and shape the future together.', cta: 'Join Pilot Program', ctaColor: 'text-blue-600'},
//     {icon: Handshake, color: 'bg-purple-100 text-purple-600', title: 'Partnerships', desc: 'Explore collaboration opportunities with us.', cta: 'Explore Partnerships', ctaColor: 'text-purple-600'},
//     {icon: Phone, color: 'bg-orange-100 text-orange-600', title: 'Talk to Sales', desc: 'Speak with our team about your specific needs.', cta: 'Contact Sales', ctaColor: 'text-orange-600'},
//   ];

//   return (
//     <section className="bg-white py-16 lg:py-24">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-12">
//           <h2 className="text-3xl font-bold text-gray-900 mb-2">How we can work together</h2>
//           <p className="text-gray-500">Choose the path that fits your organization.</p>
//         </div>

//         <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
//           {options.map(opt => (
//             <div key={opt.title} className="border border-gray-100 rounded-xl p-6 hover:shadow-lg transition-shadow">
//               <div className={\`w-12 h-12 \${opt.color} rounded-xl flex items-center justify-center mb-4\`}>
//                 <opt.icon className="w-6 h-6"/>
//               </div>
//               <h3 className="font-semibold text-gray-900 mb-2">{opt.title}</h3>
//               <p className="text-sm text-gray-500 mb-4">{opt.desc}</p>
//               <a href="#" className={\`text-sm font-medium \${opt.ctaColor} flex items-center gap-1 hover:gap-2 transition-all\`}>
//                 {opt.cta} <ArrowRight className="w-4 h-4"/>
//               </a>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// const Footer = () => {
//   return (
//     <footer className="bg-gray-50 border-t py-12">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex flex-col md:flex-row justify-between items-center gap-4">
//           <div className="flex items-center gap-2">
//             <div className="w-8 h-8 bg-emerald-600 rounded-lg flex items-center justify-center">
//               <svg viewBox="0 0 24 24" className="w-5 h-5 text-white" fill="currentColor">
//                 <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
//               </svg>
//             </div>
//             <span className="text-lg font-bold text-gray-900">TerraWeb</span>
//           </div>
//           <p className="text-sm text-gray-500">© 2026 TerraWeb. All rights reserved.</p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// // --- Main App ---

// export default function App() {
//   return (
//     <div className="min-h-screen bg-white">
//       <Navbar/>
//       <HeroSection/>
//       <TrustBadges/>
//       <StorySection/>
//       <FeaturesSection/>
//       <ValuesSection/>
//       <CTABanner/>
//       <WorkTogetherSection/>
//       <Footer/>
//     </div>
//   );
// }`}
//             </pre>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }








import React, { useState } from 'react';
import 'tachyons/css/tachyons.min.css';
import { useNavigate } from "react-router";



// --- Inline SVG Icons (replacing lucide-react) ---

const IconShield = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <path d="M9 12l2 2 4-4"/>
  </svg>
);

const IconCloud = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/>
  </svg>
);

const IconBarChart = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="16"/>
  </svg>
);

const IconUsers = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const IconHeadphones = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 18v-6a9 9 0 0 1 18 0v6"/>
    <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/>
  </svg>
);

const IconChevronDown = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

const IconArrowRight = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
  </svg>
);

const IconMenu = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/>
  </svg>
);

const IconX = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

const IconCheckCircle = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
  </svg>
);

const IconTrendingUp = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>
  </svg>
);

const IconMessageSquare = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </svg>
);

const IconDollarSign = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
  </svg>
);

const IconCloudOff = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22.61 16.95A5 5 0 0 0 18 10h-1.26A8 8 0 1 0 3 16.29"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

const IconZap = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
  </svg>
);

const IconClock = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
  </svg>
);

const IconTarget = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
  </svg>
);

const IconHeartHandshake = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19.414 14.414C21 12.828 22 11.5 22 9.5a5.5 5.5 0 0 0-9.591-3.676.6.6 0 0 1-.818.002A5.5 5.5 0 0 0 2 9.5c0 2.3 1.5 4 3 5.5l5.535 5.362a2 2 0 0 0 2.879.052 2.12 2.12 0 0 0 .521-2.2L12 15"/>
    <path d="M8 15l1.535 1.535a2 2 0 0 0 2.879.052 2.12 2.12 0 0 0 .521-2.2L12 12"/>
    <path d="M14 9l-1 1"/><path d="M16.535 12.535L15 14"/>
  </svg>
);

const IconCalendar = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);

const IconUserPlus = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/>
    <line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/>
  </svg>
);

const IconHandshake = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.42 4.58a5.4 5.4 0 0 0-7.65 0l-.77.78-.77-.78a5.4 5.4 0 0 0-7.65 7.65l.77.78 7.65 7.65 7.65-7.65.77-.78a5.4 5.4 0 0 0 0-7.65z"/>
    <path d="M12 12h.01"/>
  </svg>
);

const IconPhone = ({className}) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

// Brand emerald color
const EMERALD = '#059669';
const EMERALD_DARK = '#047857';
const EMERALD_LIGHT = '#d1fae5';
const DARK_BG = '#0f172a';

// --- Components ---

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="pa3 white relative overflow-hidden" style={{backgroundColor: DARK_BG}}>
      <div className=" center ph3 pv5 pv6-l">
        <div className="flex flex-wrap items-center">
          <div className="w-100 w-50-l pr4-l mb4 mb0-l">
      <h1 className="f2 f1-l fw7 lh-title mb3" style={{color: '#34d399'}}>About TerraWeb</h1>
            <h1 className="f2 f1-l fw7 lh-title mb3">
              Building Digital Infrastructure<br/>for Stronger Cooperatives
            </h1>
            <p className="white-70 f5 lh-copy mb4" style={{maxWidth: '480px'}}>
              TerraWeb empowers agricultural societies, cooperatives, and organizations with connected tools to manage operations, engage members, and make data-driven decisions.
            </p>
            <div className="flex flex-wrap mb4">
              <button onClick={() => navigate("/contactus")} className="white pv3 ph4 br2 f6 fw5 mr3 mb2 bn pointer flex items-center" style={{backgroundColor: EMERALD}}>
                Request Demo <IconArrowRight className="w1 h1 ml2"/>
              </button>
              <button onClick={() => navigate("/")} className="white-80 ba b--white-30 pv3 ph4 br2 f6 fw5 mb2 bn pointer bg-transparent">
                Explore Platform
              </button>
            </div>
            <div className="flex items-center">
              {/* <div className="flex mr3">
                {[1,2,3,4,5].map(i => (
                  <div key={i} className="w2 h2 br-100 ba b--dark-gray flex items-center justify-center f7 white mr1" style={{backgroundColor: '#4b5563', marginLeft: i > 1 ? '-8px' : '0', zIndex: 6-i, position: 'relative'}}>
                    {String.fromCharCode(64 + i)}
                  </div>
                ))}
              </div> */}
              <p className="white-60 f6">Trusted by forward-thinking organizations</p>
            </div>
          </div>

          <div className="w-100 w-50-l flex justify-center justify-end-l">
            <div className="bg-white br3 shadow-4 overflow-hidden" style={{maxWidth: '520px', width: '100%'}}>
              <div className="flex">
                {/* <div className="w-40 bg-light-gray pa3 dn db-ns" style={{backgroundColor: '#f9fafb', minWidth: '140px'}}>
                   <div className="flex items-center mb4">
                    <div className="w1 h1 br1 flex items-center justify-center mr2" style={{backgroundColor: EMERALD}}>
                      <svg viewBox="0 0 24 24" className="w-75 h-75 white" fill="currentColor"><path d="M12 2L2 7l10 5 10-5-10-5z"/></svg>
                    </div>
                    <span className="f6 fw6 dark-gray">TerraWeb</span>
                  </div> 
                  <div className="flex flex-column">
                    {['Dashboard','Collections','Members','Finance','Messaging','Reports','Settings'].map((item, idx) => (
                      <div key={item} className={`flex items-center pa2 mb1 br2 f7 ${idx === 0 ? 'white' : 'gray'}`} style={idx === 0 ? {backgroundColor: EMERALD} : {}}>
                        <div className="w1 h1 mr2 br1" style={{backgroundColor: idx === 0 ? 'rgba(255,255,255,0.3)' : '#e5e7eb'}}></div>
                        {item}
                      </div>
                    ))}
                  </div> 
                </div> */}

                <div className="w-60 pa3" style={{backgroundColor: '#f8f9fa', flex: 1}}>
                  <div className="flex justify-between items-center mb3">
                    <span className="f5 fw6 dark-gray">Dashboard</span>
                    <div className="flex items-center">
                      <div className="w2 h2 br-100 flex items-center justify-center f7 fw6 mr2" style={{backgroundColor: EMERALD_LIGHT, color: EMERALD}}>JW</div>
                      <div className="dn db-ns">
                        <p className="f7 fw5 dark-gray mb0">Jane Wanjiku</p>
                        <p className="f7 gray mt0">Admin</p>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-wrap justify-between mb3">
                    {[
                      {label: 'Total Farmers', val: '2,450'},
                      {label: 'Collections (Today)', val: '8,750 L'},
                      {label: 'Total Payouts', val: 'KES 1.2M'},
                      {label: 'Active Cooperatives', val: '32'}
                    ].map(stat => (
                      <div key={stat.label} className="bg-white br2 pa2 mr2 mb2" style={{minWidth: '70px', flex: '1 1 45%'}}>
                        <div className="f7 gray mb1">{stat.label}</div>
                        <div className="f6 fw6 dark-gray">{stat.val}</div>
                      </div>
                    ))}
                  </div>

                  <div className="bg-white br2 pa3 mb3">
                    <div className="flex justify-between mb2">
                      <span className="f7 fw6 dark-gray">Collection Overview</span>
                      <div className="flex">
                        <span className="f7 gray mr2 flex items-center"><span className="w1 h1 br-100 dib mr1" style={{backgroundColor: EMERALD}}></span> Milk</span>
                        <span className="f7 gray flex items-center"><span className="w1 h1 br-100 dib mr1" style={{backgroundColor: '#60a5fa'}}></span> Coffee</span>
                      </div>
                    </div>
                    <svg viewBox="0 0 300 80" className="w-100" style={{height: '60px'}}>
                      <path d="M0,60 Q30,50 60,55 T120,40 T180,45 T240,30 T300,35" fill="none" stroke={EMERALD} strokeWidth="2"/>
                      <path d="M0,65 Q30,60 60,62 T120,55 T180,58 T240,50 T300,52" fill="none" stroke="#60a5fa" strokeWidth="2"/>
                    </svg>
                    <div className="flex justify-between mt1">
                      {['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].map(d => (
                        <span key={d} className="f7 gray">{d}</span>
                      ))}
                    </div>
                  </div>

                  <div className="flex justify-between">
                    <div className="bg-white br2 pa2 mr2" style={{width: '48%'}}>
                      <div className="f7 fw6 dark-gray mb2">Payout Summary</div>
                      <div className="flex items-center">
                        <svg viewBox="0 0 60 60" width="40" height="40">
                          <circle cx="30" cy="30" r="25" fill="none" stroke="#e5e7eb" strokeWidth="6"/>
                          <circle cx="30" cy="30" r="25" fill="none" stroke={EMERALD} strokeWidth="6" strokeDasharray="60 100" transform="rotate(-90 30 30)"/>
                          <circle cx="30" cy="30" r="25" fill="none" stroke="#60a5fa" strokeWidth="6" strokeDasharray="30 100" strokeDashoffset="-60" transform="rotate(-90 30 30)"/>
                        </svg>
                        <div className="ml2">
                          <div className="f7 gray">KES 1,250,000</div>
                          <div className="f7 gray">KES 850,000</div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-white br2 pa2" style={{width: '48%'}}>
                      <div className="f7 fw6 dark-gray mb2">Top Cooperatives</div>
                      {['Kagumo Dairy Cooperative', 'Mutha Farmers Society', 'The Future Cooperative'].map((name, i) => (
                        <div key={name} className="flex items-center mb1">
                          <div className="w1 h1 br-100 mr2" style={{backgroundColor: i === 0 ? EMERALD : i === 1 ? '#60a5fa' : '#9ca3af'}}></div>
                          <span className="f7 gray truncate">{name}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const TrustBadges = () => {
  const badges = [
    {icon: IconShield, title: 'Secure & Reliable', desc: 'Enterprise-grade security to protect your data'},
    {icon: IconCloud, title: 'Accessible Anywhere', desc: 'Works on mobile and web, online or offline'},
    {icon: IconBarChart, title: 'Real-time Insights', desc: 'Up-to-date data for better decisions'},
    {icon: IconUsers, title: 'Built for Cooperatives', desc: 'Designed around real cooperative workflows'},
    {icon: IconHeadphones, title: 'Dedicated Support', desc: "We're with you every step of the way"},
  ];

  return (
    <section className="bg-white pv4 bb b--light-gray">
      <div className=" center ph3">
        <div className="flex flex-wrap justify-between">
          {badges.map(badge => {
            const Icon = badge.icon;
            return (
              <div key={badge.title} className="w-100 w-50-m w-20-l pa3 flex items-start">
                <Icon className="w1 h1 flex-shrink-0 mt1 mr3" style={{color: EMERALD}} />
                <div>
                  <p className="f6 fw6 dark-gray mb1">{badge.title}</p>
                  <p className="f7 gray lh-copy">{badge.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

const StorySection = () => {
  const navigate = useNavigate();

  return (
    <section className="bg-white pv5 pv6-l">
      <div className=" center ph3">
        <div className="flex flex-wrap items-center">
          <div className="w-100 w-50-l pr4-l mb4 mb0-l">
            <div className="flex flex-wrap">
              <div className="w-50 pr2 mb2">
                <div className="br3 overflow-hidden" style={{height: '180px', backgroundColor: EMERALD_LIGHT}}>
                  <img src="./img/cowgirl.jpeg?w=400&h=300&fit=crop" alt="Farmer with tablet" className="w-100 h-100 object-cover"/>
                </div>
              </div>
              <div className="w-50 pl2 mb2">
                <div className="br3 overflow-hidden" style={{height: '180px', backgroundColor: '#fff7ed'}}>
                  <img src="./img/coffee bean.jpg?w=400&h=300&fit=crop" alt="Coffee cherries" className="w-100 h-100 object-cover"/>
                </div>
              </div>
              <div className="w-50 pr2">
                <div className="br3 overflow-hidden" style={{height: '180px', backgroundColor: '#f3f4f6'}}>
                  <img src="./img/milk cans.jpg?w=400&h=300&fit=crop" alt="Milk cans" className="w-100 h-100 object-cover"/>
                </div>
              </div>
              <div className="w-50 pl2">
                <div className="pa3 br3" style={{backgroundColor: EMERALD}}>
                  <div className="flex items-center mb2">
                    <div className="w2 h2 br-100 white f7 fw6 flex items-center justify-center mr2" style={{backgroundColor: 'rgba(255,255,255,0.2)'}}>$$</div>
                  </div>
                  <p className="white f6 lh-copy">
                    We exist to simplify operations so cooperatives can thrive.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="w-100 w-50-l pl4-l">
            <p className="f6 fw6 ttu tracked mb3" style={{color: EMERALD}}>Our Story</p>
            <h2 className="f2 fw7 dark-gray lh-title mb3">
              Born from real challenges.<br/>Built for real impact.
            </h2>
            <p className="gray f5 lh-copy mb3">
              We saw hardworking farmers and cooperative leaders struggle with manual records, delayed payments, poor communication, and fragmented data. These challenges slow growth and weaken trust.
            </p>
            <p className="gray f5 lh-copy mb3">
              TerraWeb was created to change that.
            </p>
            <p className="gray f5 lh-copy mb4">
              We are building the digital foundation that helps cooperatives operate smarter, transparently, and sustainably.
            </p>
            <button onClick={() => navigate("/")} className="white pv3 ph4 br2 f6 fw5 bn pointer flex items-center" style={{backgroundColor: EMERALD}}>
              Our Mission <IconArrowRight className="w1 h1 ml2"/>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

const FeaturesSection = () => {
  const features = [
    {icon: IconCloudOff, title: 'Collection Management', desc: 'Digitize collection processes for milk, coffee, and more.'},
    {icon: IconUsers, title: 'Member Management', desc: 'Maintain accurate member records and engagement.'},
    {icon: IconDollarSign, title: 'Finance & Payouts', desc: 'Automate calculations and payouts with transparency.'},
    {icon: IconMessageSquare, title: 'Communication', desc: 'Connect members and leaders instantly and effectively.'},
    {icon: IconTrendingUp, title: 'Reports & Analytics', desc: 'Get insights that drive smarter decisions.'},
  ];

  return (
    <section className="pv5 pv6-l" style={{backgroundColor: '#f9fafb'}}>
      <div className="center ph3">
        <div className="tc mb5">
          <p className="f6 fw6 ttu tracked mb3" style={{color: EMERALD}}>What We Do</p>
          <h2 className="f2 fw7 dark-gray">All-in-one platform for cooperative success</h2>
        </div>

        <div className="flex flex-wrap justify-between">
          {features.map(f => {
            const Icon = f.icon;
            return (
              <div key={f.title} className="w-100 w-50-m w-20-l pa3">
                <div className="bg-white br3 pa4 shadow-1">
                  <div className="w3 h3 br3 flex items-center justify-center mb3" style={{backgroundColor: EMERALD_LIGHT}}>
                    <Icon className="w1 h1" style={{color: EMERALD}} />
                  </div>
                  <h3 className="f5 fw6 dark-gray mb2">{f.title}</h3>
                  <p className="f6 gray lh-copy">{f.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

const ValuesSection = () => {
  const values = [
    {icon: IconCheckCircle, title: 'Integrity', desc: 'We operate with honesty and transparency.'},
    {icon: IconZap, title: 'Innovation', desc: 'We build simple, smart solutions that scale.'},
    {icon: IconClock, title: 'Reliability', desc: 'We deliver systems you can count on every day.'},
    {icon: IconTarget, title: 'Simplicity', desc: 'We make technology easy and accessible.'},
    {icon: IconHeartHandshake, title: 'Impact', desc: 'We are committed to empowering communities.'},
  ];

  return (
    <section className="bg-white pv5">
      <div className=" center ph3">
        <p className="f6 fw6 ttu tracked mb4 tc" style={{color: EMERALD}}>Our Values</p>
        <div className="flex flex-wrap justify-between">
          {values.map(v => {
            const Icon = v.icon;
            return (
              <div key={v.title} className="w-100 w-50-m w-20-l pa3 tc">
                <div className="w2 h2 br-100 flex items-center justify-center center mb3" style={{backgroundColor: EMERALD_LIGHT}}>
                  <Icon className="w1 h1" style={{color: EMERALD}} />
                </div>
                <h3 className="f5 fw6 dark-gray mb1">{v.title}</h3>
                <p className="f6 gray lh-copy">{v.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

const CTABanner = () => {
  const navigate = useNavigate();
  
  return (
    <section className="pv4">
      <div className="center ph3">
        <div className="br3 pa4 pa5-l flex flex-wrap items-center justify-between" style={{backgroundColor: DARK_BG}}>
          <div className="flex items-center w-100 w-70-l mb3 mb0-l">
            <div className="w3 h3 br-100 flex items-center justify-center flex-shrink-0 mr3" style={{backgroundColor: 'rgba(5,150,105,0.2)'}}>
              <IconHandshake className="w2 h2" style={{color: '#34d399'}} />
            </div>
            <div>
              <h3 className="f3 fw7 white mb1">Let's build stronger cooperatives together</h3>
              <p className="white-60 f5">Join organizations already transforming operations with TerraWeb.</p>
            </div>
          </div>
          <div className="w-100 w-30-l flex flex-wrap justify-end-l">
            <button onClick={() => navigate("/register")} className="white pv3 ph4 br2 f6 fw5 mr3 mb2 mb0-l bn pointer flex items-center" style={{backgroundColor: EMERALD}}>
              Partner With Us <IconArrowRight className="w1 h1 ml2"/>
            </button>
            <button onClick={() => navigate("/contactus")} className="white-80 ba b--white-30 pv3 ph4 br2 f6 fw5 mb2 bn pointer bg-transparent">
              Contact Sales
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

const WorkTogetherSection = () => {
  const options = [
    {href:'https://terraweb.africa/contactus',icon: IconCalendar, color: EMERALD_LIGHT, iconColor: EMERALD, title: 'Request a Demo', desc: 'See how TerraWeb can transform your operations.', cta: 'Book a Demo', ctaColor: EMERALD},
    {href:'https://terraweb.africa/register',icon: IconUserPlus, color: '#dbeafe', iconColor: '#2563eb', title: 'Become a Pilot Partner', desc: 'Be among our early partners and shape the future together.', cta: 'Join Pilot Program', ctaColor: '#2563eb'},
    {href:'https://terraweb.africa/contactus',icon: IconHandshake, color: '#f3e8ff', iconColor: '#9333ea', title: 'Partnerships', desc: 'Explore collaboration opportunities with us.', cta: 'Explore Partnerships', ctaColor: '#9333ea'},
    {href:'https://terraweb.africa/contactus',icon: IconPhone, color: '#ffedd5', iconColor: '#ea580c', title: 'Talk to Sales', desc: 'Speak with our team about your specific needs.', cta: 'Contact Sales', ctaColor: '#ea580c'},
  ];

  return (
    <section className="bg-white pv5 pv6-l">
      <div className=" center ph3">
        <div className="tc mb5">
          <h2 className="f2 fw7 dark-gray mb2">How we can work together</h2>
          <p className="gray f5">Choose the path that fits your organization.</p>
        </div>

        <div className="flex flex-wrap justify-between">
          {options.map(opt => {
            const Icon = opt.icon;
            return (
              <div key={opt.title} className="w-100 w-50-m w-25-l pa3">
                <div className="pa4 br3" style={{backgroundColor: '#f9fafb'}}>
                  <div className="w3 h3 br3 flex items-center justify-center mb3" style={{backgroundColor: opt.color}}>
                    <Icon className="w1 h1" style={{color: opt.iconColor}} />
                  </div>
                  <h3 className="f5 fw6 dark-gray mb2">{opt.title}</h3>
                  <p className="f6 gray lh-copy mb3">{opt.desc}</p>
                  <a href={opt.href} className="link f6 fw5 flex items-center" style={{color: opt.ctaColor}}>
                    {opt.cta} <IconArrowRight className="w1 h1 ml1"/>
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

// const Footer = () => {
//   return (
//     <footer className="pv5" style={{backgroundColor: DARK_BG}}>
//       <div className="mw8 center ph3">
//         <div className="flex flex-wrap justify-between mb4">
//           <div className="w-100 w-30-l mb4 mb0-l">
//             <div className="flex items-center mb3">
//               <div className="w2 h2 br2 flex items-center justify-center mr2" style={{backgroundColor: EMERALD}}>
//                 <svg viewBox="0 0 24 24" className="w1 h1 white" fill="currentColor">
//                   <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
//                 </svg>
//               </div>
//               <span className="f4 fw6 white">TerraWeb</span>
//             </div>
//             <p className="white-60 f6 lh-copy">
//               Building digital infrastructure for stronger agricultural cooperatives across Africa.
//             </p>
//           </div>
//           <div className="w-100 w-60-l flex flex-wrap justify-between">
//             {[
//               {title: 'Product', links: ['Platform', 'Solutions', 'Pricing', 'Security']},
//               {title: 'Company', links: ['About Us', 'Careers', 'Blog', 'Press']},
//               {title: 'Resources', links: ['Documentation', 'Help Center', 'Community', 'Status']},
//               {title: 'Legal', links: ['Privacy', 'Terms', 'Cookies']}
//             ].map(col => (
//               <div key={col.title} className="w-50 w-25-ns mb3">
//                 <h4 className="f6 fw6 white mb3">{col.title}</h4>
//                 {col.links.map(link => (
//                   <a key={link} href="#" className="db link white-60 f6 mb2 hover-white">{link}</a>
//                 ))}
//               </div>
//             ))}
//           </div>
//         </div>
//         <div className="pt4 bt b--white-10">
//           <p className="white-40 f7 tc">© 2026 TerraWeb. All rights reserved.</p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// --- Main App ---

export default function Services() {
  return (
    <div className="min-h-100 bg-white">
    {/* <div className="min-h-100 bg-white"> */}
      {/* <Navbar/> */}
      <HeroSection/>
      <TrustBadges/>
      <StorySection/>
      <FeaturesSection/>
      <ValuesSection/>
      <CTABanner/>
      <WorkTogetherSection/>
      {/* <Footer/> */}
    </div>
  );
}